import { Vector2, WebGLRenderTarget } from "three";
import { Advection } from "./fbos/Advection";
import { globalParams } from "./global";
import { CircularMotion } from "./fbos/CircularMotion";
import { ExternalForce } from "./fbos/ExternalForce";
import { Divergence } from "./fbos/Divergence";
import { Poisson } from "./fbos/Poisson";
import { Pressure } from "./fbos/Pressure";

export class SimulationMgr {
    constructor(props) {
        this.props = props;
        this.fbos = {
            vel_0: null,
            vel_1: null,
            dye_1: null,
            dye_2: null,
            div: null,
            pressure_0: null,
            pressure_1: null
        };
        this.fboSize = new Vector2();
        this.cellScale = new Vector2();
        this.boundarySpace = new Vector2();
        this.init()
    }
    init() {
        this.calcSize();
        this.createAllFBO();
        this.createShaderPass()
    }
    createAllFBO() {
        const e = /(iPad|iPhone|iPod)/g.test(navigator.userAgent) ? 1016 : 1015;
        for (let t in this.fbos)
            this.fbos[t] = new WebGLRenderTarget(this.fboSize.x,this.fboSize.y,{
                type: e
            })
    }
    createShaderPass() {
        this.advection = new Advection({
            common: this.props.common,
            cellScale: this.cellScale,
            fboSize: this.fboSize,
            dt: globalParams.options.dt,
            src: this.fbos.vel_0,
            dst: this.fbos.vel_1
        });
        this.circularMotion = new CircularMotion({
            mouse: this.props.mouse,
            common: this.props.common,
            cellScale: this.cellScale,
            cursor_size: globalParams.options.cursor_size,
            dst: this.fbos.vel_1
        });
        this.props.allowCursor && (this.externalForce = new ExternalForce({
            mouse: this.props.mouse,
            common: this.props.common,
            cellScale: this.cellScale,
            cursor_size: globalParams.options.cursor_size,
            dst: this.fbos.vel_1
        }));
        this.divergence = new Divergence({
            common: this.props.common,
            cellScale: this.cellScale,
            boundarySpace: this.boundarySpace,
            dt: globalParams.options.dt,
            src: this.fbos.vel_1,
            dst: this.fbos.div
        });
        this.poisson = new Poisson({
            common: this.props.common,
            cellScale: this.cellScale,
            boundarySpace: this.boundarySpace,
            src: this.fbos.div,
            dst: this.fbos.pressure_1,
            dst_: this.fbos.pressure_0
        });
        this.pressure = new Pressure({
            common: this.props.common,
            cellScale: this.cellScale,
            boundarySpace: this.boundarySpace,
            src_p: this.fbos.pressure_0,
            src_v: this.fbos.vel_1,
            dst: this.fbos.vel_0,
            dt: globalParams.options.dt
        });
    }
    calcSize() {
        const e = Math.round(globalParams.options.resolution * this.props.common.width)
          , t = Math.round(globalParams.options.resolution * this.props.common.height)
          , i = 1 / e
          , s = 1 / t;
        this.cellScale.set(i, s);
        this.fboSize.set(e, t);
    }
    resize() {
        this.calcSize();
        for (let key in this.fbos)
            this.fbos[key].setSize(this.fboSize.x, this.fboSize.y)
    }
    update() {
        globalParams.options.isBounce ? this.boundarySpace.set(0, 0) : this.boundarySpace.copy(this.cellScale),
        this.advection.update(globalParams.options);
        this.props.allowCursor && this.externalForce.update({
            cursor_size: globalParams.options.cursor_size,
            mouse_force: globalParams.options.mouse_force,
            cellScale: this.cellScale
        });
        this.circularMotion.update({
            cursor_size: globalParams.options.cursor_size,
            mouse_force: globalParams.options.mouse_force,
            cellScale: this.cellScale
        });
        let e = this.fbos.vel_1;
        this.divergence.update({
            vel: e
        });
        const poisson_output = this.poisson.update({
            iterations: globalParams.options.iterations_poisson
        });
        this.pressure.update({
            vel: e,
            pressure: poisson_output
        });
    }
}